module.exports = __webpack_public_path__ + "static/media/Jim.f2533969.png";